"use strict";
/* GSheet implementation

ESP(dBm) = 10*LOG10[10^(RSSIdBm/10) – 10^(RSSIdBm/10) / (1+10^(SNRdB/10))]
=10*LOG10(10^(A9/10)-(10^(A9/10)/(1+10^(B9/10))))

A = 10*LOG10(10^(rssi/10)
B = 10^(rssi/10)
C = 1+10^(snr/10)

SNR = A - B/C
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEsp = void 0;
const ten = 10;
const one = 1;
const toEsp = (rssi, snr) => {
    let esp = undefined;
    if (rssi && snr) {
        const B = Math.pow(ten, rssi / ten);
        const C = one + Math.pow(ten, snr / ten);
        const A = ten * Math.log10(Math.pow(ten, rssi / ten) - B / C);
        esp = A;
    }
    return esp;
};
exports.toEsp = toEsp;
